const HeroBannerComp = ({ image, title, description, className }) => {
  return (
    <div className={`herobanner__comp ${className || ""}`}>
      <img src={image} alt={title} className="hero-img" />
      <div className="hero-overlay">
        <h4>{title}</h4>
        <a href="mailto:info@taarts.net">
          <button className="hero-button">Email Us</button>
        </a>
      </div>
    </div>
  );
};

export default HeroBannerComp;
